import React, { useCallback } from 'react';
import { createFormField } from 'Shared/utils/createFormField';

import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';

type Props = {
  options: Array<{
    value: string | number;
    label: string;
  }>;
  onChange: Function;
  value: Array<string>;
  className: string;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  error: string;
  touched: boolean;
  errorLabel?: boolean;
};

function setValue(values, fieldValue) {
  if (!values) return [fieldValue];
  if (Array.isArray(values) && values.includes(fieldValue)) return values.filter(e => e !== fieldValue);
  if (!Array.isArray(values) && values === fieldValue) return [];
  return [...values, fieldValue];
}

function isChecked(values, optionValue) {
  if (!values) return false;
  if (Array.isArray(values)) return values.includes(optionValue.toString());
  return values === optionValue.toString();
}

export function CheckboxGroup({
  value,
  onChange,
  onFocus,
  onBlur,
  options,
  className,
  error,
  touched,
  errorLabel = true,
}: Props) {
  const handleChange = useCallback(
    fieldValue => {
      onChange(setValue(value, String(fieldValue)));
      setTimeout(onFocus);
      setTimeout(onBlur);
    },
    [onChange, value, onBlur, onFocus]
  );
  return (
    <div className={`d-flex flex-column ${className}`}>
      {options.map(option => (
        <StyledCheckbox
          key={option.value}
          className="my-1"
          value={option.value}
          checked={isChecked(value, option.value)}
          onChange={handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
          label={option.label}
        />
      ))}
      {touched && error && errorLabel ? <p className="form-input-error text-danger">{error}</p> : null}
    </div>
  );
}

export default createFormField(CheckboxGroup);
